/**
 * Domäne einer E-Mail-Adresse — Spiegelung der Backend-Regel (`EmailDomains.extract`):
 * Teil nach dem letzten `@`, getrimmt, kleingeschrieben; `null`, wenn nicht auswertbar.
 *
 * Liegt hier statt im Feature-Ordner, weil es dieselbe Kategorie ist wie `field-lengths.ts`:
 * eine BE-Regel, die das FE nachbildet. Weicht sie ab, meldet das Formular etwas anderes als
 * der maßgebliche Guard im Backend.
 */
export function emailDomain(email: string): string | null {
  const trimmed = email.trim();
  const at = trimmed.lastIndexOf('@');
  if (at <= 0) return null;
  const domain = trimmed
    .slice(at + 1)
    .trim()
    .toLowerCase();
  return domain || null;
}

/** Exakter, case-insensitiver Treffer auf der Allow-List — bewusst kein Suffix-Match. */
export function isDomainAllowed(email: string, allowedDomains: readonly string[]): boolean {
  const domain = emailDomain(email);
  if (domain === null) return false;
  return allowedDomains.some((d) => d.trim().toLowerCase() === domain);
}
